import React from 'react';
import { useNavigate } from 'react-router-dom';
import constants from '../config/consts';
import '../styles/CubesMagnCard.css';

const CubesMagnCard = ({ product, onClick }) => {
  const navigate = useNavigate();
  
  // Первое изображение из строки images (разделены запятой) или preViewImg
  const firstImage = product.images?.split(',')[0] || product.preViewImg;
  console.log(product);
  

  return (
    <div className="CubesMagnCard" onClick={onClick}>
      <div className="cubesMagnCardImageContainer">
        <img className='cubesMagnCardImage'
          src={`${constants.serverUrl}${firstImage}`} 
          alt={product.title} 
        />
      </div>
      <p className="cubesMagnCardTitle">{product.title}</p>
      <p className="cubesMagnCardTitle">{product.description}</p>
      <p className="cubesMagnCardPrice">{product.price} ₽/{product.category == 'Кубики' ? 'набор' : 'шт'}</p>
    </div>
  );
};

export default CubesMagnCard;